import { getSession } from "@/lib/utils";

async function apiClient({
  path,
  options = {},
  headers = {},
  tags,
  cache = "force-cache",
  skipAuth = false,
}) {
  //const session = await getSession();
  //const token = skipAuth ? null : session?.user?.accessToken;
  const tenantSlug = process.env.TENANT_SLUG || "alhome";
  let token = null;
  if (!skipAuth) {
    const session = await getSession();
    token = session?.user?.accessToken;
  }
  try {
    // Merge default and user options
    const mergedOptions = {
      headers: {
        "Content-Type": "application/json",
        "x-ocp-tenant-slug": tenantSlug,
        ...(token && { Authorization: `Bearer ${token}` }),
        isGuest: token ? false : true,
        ...headers,
      },
      ...options,
      cache: cache,
      ...(tags && { next: { tags: Array.isArray(tags) ? tags : [tags] } }),
    };

    // Trigger API call
    const response = await fetch(path, mergedOptions);

    if (response.status === 401 || response.status === 403) {
      return {
        statusCode: response.status,
        message: "Unauthorized Access. Please login again...",
      };
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw new Error(
      `Please check if your server is running and you set all the required tokens.`
    );
  }
}

export default apiClient;
